export default "__VITE_ASSET__CfrPqfvJ__"